import PbDarkInfo from '@/assets/data-dashboard/dark-pbinfo-logo.png'
import PbInfo from '@/assets/data-dashboard/pbinfo-logo.png'
export const staticConfig = {
  '51wl': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/51wl/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/51wl/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/51wl/3.png',
    FavTitle: '搜索排名',
    filing: '皖ICP备18001927号-16',
    rootDomain: 'yunshiyouke.com.cn',
    licenseKey: 'nP6mUq6JE0BFqRTPp0956031a9cf949f0a54341db8b61fc31',
    shareUrl: 'https://ai.yunshiyouke.com.cn'
  },
  'fengyin': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/fengyin/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/fengyin/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/fengyin/3.png',
    FavTitle: '云视搜索',
    filing: '蜀ICP备2024055338号-1',
    rootDomain: 'yunshiyouke.com.cn',
    licenseKey: 'nP6mUq6JE0BFqRTPp0956031a9cf949f0a54341db8b61fc31',
    shareUrl: 'https://ai.yunshiyouke.com.cn'
  },
  'juyuai': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/juyuai/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/juyuai/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/juyuai/3.png',
    FavTitle: '巨宇AI获客',
    filing: '浙ICP备12013743号-16',
    rootDomain: 'yunshiyouke.com.cn',
    licenseKey: 'nP6mUq6JE0BFqRTPp0956031a9cf949f0a54341db8b61fc31',
    shareUrl: 'https://ai.yunshiyouke.com.cn'
  },
  'qiteng518': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/qiteng518/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/qiteng518/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/qiteng518/3.png',
    FavTitle: '剪辑系统',
    filing: '津ICP备2022003066号-6',
    rootDomain: 'yunshiyouke.com.cn',
    licenseKey: 'nP6mUq6JE0BFqRTPp0956031a9cf949f0a54341db8b61fc31',
    shareUrl: 'https://ai.yunshiyouke.com.cn'
  },
  'tui55': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/tui55/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/tui55/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/tui55/3.png',
    FavTitle: '千里马AI获客',
    filing: '渝ICP备13002463号-18',
    rootDomain: 'yunshiyouke.com.cn',
    licenseKey: 'nP6mUq6JE0BFqRTPp0956031a9cf949f0a54341db8b61fc31',
    shareUrl: 'https://ai.yunshiyouke.com.cn'
  },
  'pbinfo': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/pbinfo/2.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/pbinfo/1.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/pbinfo/3.png',
    DarkDataLogo: PbDarkInfo,
    DataLogo: PbInfo,
    FavTitle: '鹏博资讯',
    filing: '粤ICP备11039585号-5',
    rootDomain: 'pbinfo.cn',
    licenseKey: 'zPtL9R8wGPumTmq2C434ab2bc0b5341ea8f7703afef6793a8',
    shareUrl: 'https://ai.pbinfo.cn'
  },
}
